/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";

const manifest = {
  "acf/content-section": dynamic(() => import("../../../blocks/content/section.tsx"), "blocks/content/section.tsx"),
  "acf/event-event-root": dynamic(() => import("../../../blocks/event/event-root.tsx"), "blocks/event/event-root.tsx"),
  "acf/event-event-tickets": dynamic(
    () => import("../../../blocks/event/event-tickets.tsx"),
    "blocks/event/event-tickets.tsx",
  ),
  ...core,
};

const info = {
  "acf/content-section": { "slug": "content/section", "flags": {} },
  "acf/event-event-root": { "slug": "event/event-root", "tags": [], "flags": {} },
  "acf/event-event-tickets": { "slug": "event/event-tickets", "tags": ["#event-sidebar"], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
